// extracted by mini-css-extract-plugin
export default {"overlay":"Bz-z","bodyOpen":"Cz-z","content":"Dz-z","header":"Ez-z","close":"Fz-z","closeNoHeading":"Gz-z"};